import * as React from "react"

function Binocular(props) {
  return (
    <svg
      fill="none"

      xmlns="http://www.w3.org/2000/svg"
      viewBox="-7.3 -5 1452.6 1153"
      {...props}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1445.3-5H-7.299v1153H1445.3V-5zM434.149 928.222c110.364 0 209.067-49.786 274.757-128.065 65.69 78.279 164.393 128.065 274.757 128.065 197.777 0 358.107-159.884 358.107-357.111S1181.44 214 983.663 214c-110.364 0-209.067 49.786-274.757 128.065C643.216 263.786 544.513 214 434.149 214 236.373 214 76.043 373.884 76.043 571.111s160.33 357.111 358.106 357.111z"
          fill="#0D3727"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1076_7077"
          x={-17.2988}
          y={-15}
          width={1472.6}
          height={1173}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation={5}
            result="effect1_foregroundBlur_1076_7077"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Binocular
